import type {
  EquipmentItemPatchApiData,
  EquipmentItemPatchApiResponses,
  EquipmentPatchApiData,
  EquipmentPatchApiResponses,
  EquipmentTemplatePatchApiData,
  EquipmentTemplatePatchApiResponses
} from '@navio/nsdk';
import { apiUrl, responseEndpoint } from '../defineResource';

const imageFormData = (image: File) => {
  const formData = new FormData();
  formData.append('image', image);
  return formData;
};

export const equipmentImageUrls = {
  patchEquipmentItemImage: responseEndpoint<
    EquipmentItemPatchApiData,
    EquipmentItemPatchApiResponses,
    { equipmentItemId: number; image: File }
  >({
    getUrl: ({ equipmentItemId }) => apiUrl(`inventory/equipment-items/${equipmentItemId}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: ({ image }) => imageFormData(image),
    skipBodyTransformation: true
  }),
  patchEquipmentKitImage: responseEndpoint<
    EquipmentPatchApiData,
    EquipmentPatchApiResponses,
    { equipmentId: number; image: File }
  >({
    getUrl: ({ equipmentId }) => apiUrl(`inventory/equipment/${equipmentId}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: ({ image }) => imageFormData(image),
    skipBodyTransformation: true
  }),
  patchEquipmentTemplateImage: responseEndpoint<
    EquipmentTemplatePatchApiData,
    EquipmentTemplatePatchApiResponses,
    { equipmentTemplateId: number; image: File }
  >({
    getUrl: ({ equipmentTemplateId }) => apiUrl(`inventory/equipment-templates/${equipmentTemplateId}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: ({ image }) => imageFormData(image),
    skipBodyTransformation: true
  })
};
